<mat-card>
    <div class="text-center">
        <mat-chip color="accent" class="gray" >Perfil: <br><b>{{ userTypeText }}</b></mat-chip>
    </div>
    <mat-list>
        <mat-list-item  *ngFor="let menu of menus">  
            <button mat-menu-item  [routerLink]="menu.page"
                [matTooltip]=" menu.name"
                matTooltipPosition="right"
                [matTooltipDisabled]="!showTooltip" >
                <mat-icon color="primary"  [alt]="menu.name">{{menu.icon}}</mat-icon>
                <span> {{ menu.name }}</span>
            </button>   
        </mat-list-item>       
    </mat-list>
</mat-card>